import { render, staticRenderFns } from "./MessagingDocuments.vue?vue&type=template&id=fdbc5e2c"
import script from "./MessagingDocuments.vue?vue&type=script&lang=js"
export * from "./MessagingDocuments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports